import { Injectable } from '@angular/core';

/**
 * Service to dynamically load PrimeNG themes based on the current theme mode
 */
@Injectable({
  providedIn: 'root'
})
export class PrimeNGThemeLoaderService {
  private themeLink: HTMLLinkElement | null = null;
  private readonly LIGHT_THEME = 'lara-light-blue';
  private readonly DARK_THEME = 'lara-dark-blue';

  constructor() {
    this.initializeThemeLink();
  }

  /**
   * Initialize the theme link element
   */
  private initializeThemeLink(): void {
    // Find existing PrimeNG theme link
    this.themeLink = document.querySelector('link[href*="primeng/resources/themes"]');

    if (!this.themeLink) {
      // Create a new link element if not found
      this.themeLink = document.createElement('link');
      this.themeLink.rel = 'stylesheet';
      this.themeLink.id = 'primeng-theme';
      document.head.appendChild(this.themeLink);
    }
  }

  /**
   * Load a specific PrimeNG theme
   * Note: Dark theme is disabled as lara-dark-blue is not included in the build
   * To enable dark theme, add it to angular.json styles array
   */
  loadTheme(isDark: boolean): void {
    // Always use light theme for now as dark theme is not in build
    // TODO: Add lara-dark-blue to angular.json to enable dark theme
    const themeName = this.LIGHT_THEME;
    const themeUrl = `primeng/resources/themes/${themeName}/theme.css`;

    if (this.themeLink) {
      this.themeLink.href = themeUrl;
    }
  }

  /**
   * Switch to light theme
   */
  loadLightTheme(): void {
    this.loadTheme(false);
  }

  /**
   * Switch to dark theme
   */
  loadDarkTheme(): void {
    this.loadTheme(true);
  }
}
